import type { RouteLocationNormalized, RouteRecordRaw } from "vue-router";
import type { AbilitiesEvaluation } from "vue-simple-acl/types/acl";
import { useFeature } from "~/core/composables/useFeature";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import { AppFeatures } from "~/core/models/AppFeatures.enum";
import { canWithRedirection } from "~/core/utils/canWithRedirection";
import { PATH_CARTOGRAPHY } from "~/modules/cartography/constants";
import MapDevicesPage from "~/modules/cartography/views/MapDevicesPage.vue";

const { isFeatureEnabled } = useFeature();

const routes: RouteRecordRaw[] = [
  {
    path: PATH_CARTOGRAPHY,
    component: MapDevicesPage,
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) =>
        isFeatureEnabled(AppFeatures.CARTOGRAPHY) &&
        canWithRedirection(can, ACLRoles.CAN_READ_DEVICE),
    },
  },
];

export default routes;
